import { helpers as vuelidateHelpers } from "vuelidate/lib/validators";

export const isThereAValue = obj => {
    let isThereValue = false;
    Object.values(obj).forEach(Element => {
        if (Element.surface !== null && Element.price !== null)
            isThereValue = true;
    });
    return isThereValue;
};

export const isExisted = (nameKey, myArray) => {
    let exists = false;
    myArray.forEach(elem => {
        if (elem.name === nameKey) exists = true;
    });
    return exists;
};

export const supportedImageFile = value => {
    if (!vuelidateHelpers.req(value)) {
        return true;
    }
    const supported = ["jpg", "jpeg", "png", "svg"];
    const suffix = value.split(".").pop();
    return supported.includes(suffix);
};

export const errorMessage = (attribut, error) => {
    if (error.required !== undefined && !error.required)
        return `Le champ ${attribut} est obligatoire`;
};

export const downLoadFile = (data, filename, mime, bom) => {
    var blobData = typeof bom !== "undefined" ? [bom, data] : [data];
    var blob = new Blob(blobData, { type: mime || "application/octet-stream" });
    if (typeof window.navigator.msSaveBlob !== "undefined") {
        // IE workaround for "HTML7007: One or more blob URLs were
        // revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
    } else {
        var blobURL =
            window.URL && window.URL.createObjectURL
                ? window.URL.createObjectURL(blob)
                : window.webkitURL.createObjectURL(blob);
        var tempLink = document.createElement("a");
        tempLink.style.display = "none";
        tempLink.href = blobURL;
        tempLink.setAttribute("download", filename);

        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
        }

        document.body.appendChild(tempLink);
        tempLink.click();

        // Fixes "webkit blob resource error 1"
        setTimeout(function() {
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }, 200);
    }
};

export const capitalize = str => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const titleCase = str => {
    return str
        .toLowerCase()
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};

export const generateUID = () => {
    return (
        new Date().getTime() +
        String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
        Math.floor(Math.random() * Math.floor(1000))
    );
};

export const formatPrice = price => {
    if (price === null) return 0;
    return price.toLocaleString("fr", {
        // minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

export const isArrayOfZeros = (array, key) => {
    return array.every(item => item[key] === 0);
};
